module.exports = __webpack_public_path__ + "static/media/azure-developer-associate.6034e16f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/azure-developer-associate.png
// module id = 1376
// module chunks = 0